import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, sync$, $, Slot } from "@builder.io/qwik";
const HLabel = component$((props) => {
  const handleMouseDownSync$ = sync$((event) => {
    if (!event.defaultPrevented && event.detail > 1)
      event.preventDefault();
  });
  const handleMouseDown$ = $((event) => {
    const target = event.target;
    if (target.closest("button, input, select, textarea"))
      return;
  });
  return /* @__PURE__ */ jsx("label", {
    ...props,
    onMouseDown$: [
      handleMouseDownSync$,
      handleMouseDown$,
      props.onMouseDown$
    ],
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HLabel
};
